/* eslint-disable unicorn/prefer-export-from */
import "@website/ui/styles";
import { App } from "@website/widget/pages/_app";
export default App;
